import { useAuth } from '../hooks/useAuth';

export default function AdminPanel() {
     const { user, isSuperAdmin } = useAuth();

     return (
          <div>
               <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">Admin Panel</h1>
                    <div className="badge badge-success badge-lg">
                         {user?.role}
                    </div>
               </div>

               {/* Super Admin Only Section */}
               {isSuperAdmin() && (
                    <div className="row mb-4">
                         <div className="col-12">
                              <div className="card border-left-danger shadow">
                                   <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-danger">
                                             <i className="fas fa-crown mr-2"></i>
                                             Super Admin Only
                                        </h6>
                                   </div>
                                   <div className="card-body">
                                        <p>This section is only visible to Super Administrators.</p>
                                        <div className="row">
                                             <div className="col-md-4">
                                                  <button className="btn btn-danger btn-sm">
                                                       <i className="fas fa-users-cog mr-2"></i>
                                                       Manage System
                                                  </button>
                                             </div>
                                             <div className="col-md-4">
                                                  <button className="btn btn-warning btn-sm">
                                                       <i className="fas fa-database mr-2"></i>
                                                       Database Admin
                                                  </button>
                                             </div>
                                             <div className="col-md-4">
                                                  <button className="btn btn-info btn-sm">
                                                       <i className="fas fa-cogs mr-2"></i>
                                                       System Settings
                                                  </button>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}

               {/* Admin Features */}
               <div className="row">
                    <div className="col-xl-4 col-md-6 mb-4">
                         <div className="card border-left-primary shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                  User Management
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">245</div>
                                             <div className="text-xs text-muted">Active Users</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-users fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-4">
                         <div className="card border-left-success shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                  Badge Management
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">1,234</div>
                                             <div className="text-xs text-muted">Total Badges</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-medal fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-4">
                         <div className="card border-left-info shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                  Reports
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">86</div>
                                             <div className="text-xs text-muted">Generated Today</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-chart-bar fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

               {/* Admin Actions */}
               <div className="row">
                    <div className="col-12">
                         <div className="card shadow mb-4">
                              <div className="card-header py-3">
                                   <h6 className="m-0 font-weight-bold text-primary">Admin Actions</h6>
                              </div>
                              <div className="card-body">
                                   <div className="row">
                                        <div className="col-md-3 mb-3">
                                             <button className="btn btn-primary btn-block">
                                                  <i className="fas fa-user-plus mr-2"></i>
                                                  Add User
                                             </button>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                             <button className="btn btn-success btn-block">
                                                  <i className="fas fa-certificate mr-2"></i>
                                                  Create Badge
                                             </button>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                             <button className="btn btn-info btn-block">
                                                  <i className="fas fa-file-export mr-2"></i>
                                                  Export Data
                                             </button>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                             <button className="btn btn-warning btn-block">
                                                  <i className="fas fa-cog mr-2"></i>
                                                  Settings
                                             </button>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

               {/* User Info */}
               <div className="row">
                    <div className="col-12">
                         <div className="card shadow mb-4">
                              <div className="card-header py-3">
                                   <h6 className="m-0 font-weight-bold text-primary">Current Admin Details</h6>
                              </div>
                              <div className="card-body">
                                   <div className="row">
                                        <div className="col-md-6">
                                             <p><strong>Name:</strong> {user?.user_name}</p>
                                             <p><strong>User Code:</strong> {user?.user_code}</p>
                                             <p><strong>Role:</strong>
                                                  <span className={`badge ml-2 ${user?.role === 'SUPER_ADMIN' ? 'badge-danger' : 'badge-primary'}`}>
                                                       {user?.role}
                                                  </span>
                                             </p>
                                        </div>
                                        <div className="col-md-6">
                                             <p><strong>Email:</strong> {user?.email}</p>
                                             <p><strong>Admin Status:</strong>
                                                  <span className={`badge ml-2 ${user?.is_admin === 'Y' ? 'badge-success' : 'badge-secondary'}`}>
                                                       {user?.is_admin === 'Y' ? 'Admin' : 'User'}
                                                  </span>
                                             </p>
                                             <p><strong>Validity:</strong> {user?.validity}</p>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
}